import { useRef, useState } from "react"
import { Form, Button, Card, Alert, Modal, Image } from "react-bootstrap"
import { useAuth } from "../../contexts/AuthContext"
import { useHistory } from "react-router-dom"
import CenteredContainer from "./../CenteredContainer"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import { db } from "./../../firebase"
import { doc, setDoc } from "firebase/firestore"
import {
  optionsDegree,
  optionsOccupation,
  optionsAffiliation,
} from "../../helpers/Data"

// import {signInWithGoogleOther} from "../../firebase";

export default function Login() {
  const emailRef = useRef()
  const passwordRef = useRef()
  const passwordConfirmRef = useRef()
  const affiliationRef = useRef()
  const degreeRef = useRef()
  const occupationRef = useRef()
  const nameRef = useRef()
  const surnameRef = useRef()
  const paperRef = useRef(0)

  const { signup, login, resetpassword, googleSignIn, facebookSignIn } =
    useAuth()
  const [error, setError] = useState("")
  const [errorReset, setErrorReset] = useState("")
  const [emailSent, setEmailSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const [show, setShow] = useState(false)
  const [showProviders, setShowProviders] = useState(false)

  const [selectedAffiliation, setSelectedAffiliation] = useState("")
  const [affiliationText, setAffiliationText] = useState("")

  // Submit reset password
  async function handleReset(e) {
    e.preventDefault()

    try {
      setErrorReset("")

      setLoading(true)

      await resetpassword(emailRef.current.value)

      setEmailSent(true)

      setLoading(false)
    } catch (err) {
      // console.log("error",err.message)

      setErrorReset(err.code)

      setLoading(false)
    }
  }

  // Submit login with Email and Password
  async function handleSubmit(e) {
    e.preventDefault()

    try {
      setError("")

      setLoading(true)

      await login(emailRef.current.value, passwordRef.current.value)

      setLoading(false)

      history.push("/")
    } catch (err) {
      setError("Failed to sign in")
      console.log(err)
      setLoading(false)
    }
  }

  // Submit login with Google
  async function handleSubmitGoogle(e) {
    e.preventDefault()

    try {
      setError("")

      setLoading(true)

      const newUser = await googleSignIn()
      const isNewUser = newUser._tokenResponse.isNewUser
      // console.log(newUser)

      if (isNewUser) {
        // Create new user in user collection
        await setDoc(doc(db, "users", newUser.user.uid), {
          // User information
          uid: newUser.user.uid,
          email: newUser.user.email,
          subscription: false,
          Name: newUser._tokenResponse.firstName,
          Surname: newUser._tokenResponse.lastName,
          // QR information
          payment_id: 0,
          expiration_date: "",
          status: 0, // Status QR payment.
          // profileEmpty: isNewUser
        })

        setLoading(false)

        history.push("/newuser")
      } else {
        setLoading(false)

        history.push("/")
      }
    } catch {
      setError("Failed to sign in with Google Account")
      setLoading(false)
      // console.log(error.message)
    }
  }

  // Submit login with Facebook
  async function handleSubmitFacebook(e) {
    e.preventDefault()

    try {
      setError("")

      setLoading(true)

      const newUser = await facebookSignIn()
      const isNewUser = newUser._tokenResponse.isNewUser
      // console.log(newUser)
      if (isNewUser) {
        // Create new user in user collection
        await setDoc(doc(db, "users", newUser.user.uid), {
          // User information
          uid: newUser.user.uid,
          email: newUser.user.email,
          subscription: false,
          Name: newUser._tokenResponse.firstName,
          Surname: newUser._tokenResponse.lastName,
          // QR information
          payment_id: 0,
          expiration_date: "",
          status: 0, // Status QR payment.
          // profileEmpty: isNewUser
        })

        setLoading(false)

        history.push("/newuser")
      } else {
        setLoading(false)

        history.push("/")
      }
    } catch {
      setError("Failed to sign in")

      setLoading(false)
      console.log(error.message)
    }
  }

  // handleSubmit Email & Password Sign In
  async function handleSubmitEmail(e) {
    e.preventDefault()

    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError("Passwords do not match")
    } else {
      // Authenticate with email and password
      try {
        setError("")
        setLoading(true)

        const newUser = await signup(
          emailRef.current.value,
          passwordRef.current.value
        )

        // Create new user in user collection
        await setDoc(doc(db, "users", newUser.user.uid), {
          // User information
          uid: newUser.user.uid,
          email: newUser.user.email,
          Name: nameRef.current.value,
          Surname: surnameRef.current.value,
          Degree: degreeRef.current.value,
          Affiliation: affiliationRef.current.value,
          occupation: occupationRef.current.value,
          subscription: false,
          paperID: paperRef.current.value,
          // QR information
          payment_id: 0,
          expiration_date: "",
          status: 0, // Status QR payment.
        })

        setLoading(false)

        history.push("/")
      } catch (e) {
        console.log(e.message)
        setError(e.code)

        setLoading(false)
      }
    }
  }

  // Close modal
  const handleClose = () => setShow(false)
  const handleCloseEmail = () => setShowProviders(false)
  // Show modal
  const handleShow = (e) => {
    e.preventDefault()
    setShow(true)
  }

  const handleDropdownChange = (event) => {
    const selectedValue = event.target.value
    setSelectedAffiliation(selectedValue)
    affiliationRef.current.value = selectedValue // Update affiliationRef value
    if (selectedValue === "Otro") {
      affiliationRef.current.focus()
    }
  }

  const handleTextChange = (event) => {
    setAffiliationText(event.target.value)
  }

  // Reset password form
  const showResetForm = () => {
    return (
      <CenteredContainer>
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <div>Recuperar Contraseña</div>
              <div className='text-secondary fs-6'>Reset your password</div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='text-justified mt-2'>
              {errorReset && <Alert variant='danger'>{errorReset}</Alert>}
              {emailSent && (
                <Alert variant='success'>
                  <div>Solicitud enviada. Revise su correo electrónico. </div>
                  <hr className='hr-danger' />
                  <div>Request has been sent. Please check your email.</div>
                </Alert>
              )}
              <p>
                {" "}
                Ingresa el correo electrónico con el que creaste tu cuenta y te
                enviaremos un enlace para cambiar tu contraseña
              </p>
              {/* <hr className="hr-danger" /> */}
              <p className='fw-light text-secondary'>
                {" "}
                Enter your email address and we will send you an email with a
                link to reset your password
              </p>
            </div>
            <Form onSubmit={handleReset}>
              <Form.Group id='email'>
                {/* <Form.Label column xs={4}>Email</Form.Label> */}
                <Form.Control
                  placeholder='email'
                  type='email'
                  ref={emailRef}
                  required
                />
              </Form.Group>

              <Button
                disabled={loading}
                className='w-100 mt-2'
                type='resetpassword'
              >
                Send email
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
      </CenteredContainer>
    )
  }

  // Modal Sign in with Email

  // Show list of Auth providers
  function handleShowEmailForm(e) {
    e.preventDefault()
    // console.log(nameRef.current.value)
    setShowProviders(true)
    setError(false)
  }
  const showEmailSignUpForm = () => {
    return (
      <CenteredContainer>
        <Modal show={showProviders} onHide={handleCloseEmail} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <div>Crea una cuenta nueva</div>
              <div className='text-secondary fs-6'>Create a new account</div>
            </Modal.Title>
          </Modal.Header>
          {error && <Alert variant='danger'>{error}</Alert>}

          <Modal.Body>
            {/* Google SignIn */}
            <div className='w-100 fs-6 mt-1'>
              No compartimos tus datos con nadie.
            </div>
            <div className='w-100 fs-16 text-secondary mt-0'>
              We do not share any of your information.
            </div>
            <hr className='hr-danger' />

            {/* Email and password form */}
            <Form onSubmit={handleSubmitEmail}>
              <Form.Group as={Row} className='mt-2' id='email'>
                <Form.Label column xs={5}>
                  Email
                </Form.Label>
                <Col xs={7}>
                  <Form.Control
                    placeholder=' Your email'
                    type='email'
                    ref={emailRef}
                    required
                    size='sm'
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className='mt-2' id='password'>
                <Form.Label column xs={5}>
                  Contraseña
                </Form.Label>
                <Col xs={7}>
                  <Form.Control
                    placeholder='Password'
                    type='password'
                    ref={passwordRef}
                    required
                    size='sm'
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className='mt-2' id='password-confirm'>
                <Form.Label column xs={5}>
                  Confirma tu contraseña
                </Form.Label>
                <Col xs={7}>
                  <Form.Control
                    className='mt-3'
                    placeholder='Confirm Password'
                    type='password'
                    ref={passwordConfirmRef}
                    required
                    size='sm'
                  />
                </Col>
              </Form.Group>

              <hr className='hr-danger' />

              <Form.Group as={Row} id='name'>
                <Form.Label column xs={5}>
                  Nombre{" "}
                </Form.Label>
                <Col xs={7}>
                  <Form.Control
                    type='text'
                    placeholder='First Name'
                    ref={nameRef}
                    required
                    size='sm'
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} id='name'>
                <Form.Label column xs={5}>
                  Apellido{" "}
                </Form.Label>
                <Col xs={7}>
                  <Form.Control
                    type='text'
                    placeholder='Last Name'
                    ref={surnameRef}
                    required
                    size='sm'
                  />
                </Col>
              </Form.Group>

              {/* <Form.Group as={Row} id='affiliation' className='mt-2'>
                <Form.Label column xs={5}>
                  Institución
                </Form.Label>
                <Col xs={7}>
                  <Form.Control
                    type='text'
                    placeholder='Institution or affiliation'
                    ref={affiliationRef}
                    required
                    size='sm'
                  />
                </Col>
              </Form.Group> */}

              {/* Affiliation */}
              <Form.Group as={Row} id='affiliation' className='mt-2'>
                <Form.Label column xs={5}>
                  Institución
                </Form.Label>
                <Col xs={7}>
                  <Form.Select
                    aria-label='Default select example'
                    ref={affiliationRef}
                    value={selectedAffiliation}
                    onChange={handleDropdownChange}
                    placeholder='Select your Affiliation'
                    size='sm'
                    required
                  >
                    {optionsAffiliation.map((option, index) => {
                      return (
                        <option key={index} value={option.value}>
                          {option.label}
                          {/* {console.log(selectedAffiliation)} */}
                        </option>
                      )
                    })}
                  </Form.Select>
                  {selectedAffiliation === "other" && (
                    <div>
                      <Form.Label column xs={5}>
                        Institución:
                      </Form.Label>

                      <Form.Control
                        type='text'
                        // defaultValue={currentProfile.Affiliation}
                        ref={affiliationRef}
                        onChange={handleTextChange}
                        size='sm'
                        required
                        className='mt-1'
                      />
                    </div>
                  )}
                </Col>
              </Form.Group>

              <Form.Group as={Row} id='degree' className='mt-2'>
                <Form.Label column xs={5}>
                  Título académico
                </Form.Label>
                <Col xs={7}>
                  <Form.Select
                    aria-label='Default select example'
                    ref={degreeRef}
                    placeholder='Academic degree'
                    required
                    size='sm'
                  >
                    <option value='' className='text-secondary'>
                      Select option
                    </option>
                    {optionsDegree.map((option, index) => {
                      return (
                        <option key={index} value={option.value}>
                          {option.label}
                        </option>
                      )
                    })}

                    {/* <option></option>
                <option value="PhD" aria-label="PhD">Doctorado (Ph.D.)</option>
                <option value="PhD (c)" aria-label="PhDc">Candidato a Doctor (Ph.D. (c))</option>
                <option value="Maestria" aria-label="Maestria">Maestria (Master)</option>
                <option value="Licenciatura" aria-label="Licenciatura">Licenciatura (Bachelor)</option> */}
                  </Form.Select>
                </Col>
              </Form.Group>

              <Form.Group as={Row} id='degree' className='mt-2'>
                <Form.Label column xs={5}>
                  Ocupación
                </Form.Label>
                <Col xs={7}>
                  <Form.Select
                    aria-label='Default select example'
                    ref={occupationRef}
                    placeholder='Select your degree'
                    required
                    size='sm'
                  >
                    <option value='' className='text-secondary'>
                      Select option
                    </option>
                    {optionsOccupation.map((option, index) => {
                      return (
                        <option key={index} value={option.value}>
                          {option.label}
                        </option>
                      )
                    })}

                    {/* <option></option>
                <option value="Profesional" aria-label="Profesional">Profesional (Professional)</option>
                <option value="Docencia" aria-label="Docencia">Docencia (Teaching)</option>
                <option value="Investigador" aria-label="Investigador">Investigador (Research)</option>
                <option value="Estudiante" aria-label="Estudiante">Estudiante (Student)</option> */}
                  </Form.Select>
                </Col>
              </Form.Group>

              {/* <hr className="hr-danger" /> */}
              <div className='text-divider'>
                <span> Opcional | Optional</span>{" "}
              </div>
              <div className='w-100 fs-6 text-center'>
                Si eres expositor, por favor incluye el numero de tu documento.
              </div>
              <div className='w-100 fs-16 text-secondary mt-0 text-center'>
                If you are a presenter, please include you paper ID.
              </div>

              <Form.Group as={Row} id='paperID' className='mt-3'>
                <Form.Label column xs={5}>
                  Paper ID
                </Form.Label>
                <Col xs={7}>
                  <Form.Control
                    type='text'
                    placeholder='Paper ID'
                    ref={paperRef}
                    size='sm'
                  />
                </Col>
              </Form.Group>

              <Button disabled={loading} className='w-100 mt-2' type='submit'>
                Crear cuenta
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
      </CenteredContainer>
    )
  }

  // console.log(showProviders)

  return (
    <CenteredContainer>
      {show && showResetForm()}

      {showProviders && showEmailSignUpForm()}

      <Card>
        <Image
          src={require("../../images/Group12.jpg")}
          rounded
          className='w-100 border-bottom'
          style={{ maxWidth: "400px" }}
        ></Image>
        {/* <hr className="hr-danger" /> */}
        <Card.Body>
          <h2 className='text-center'>Bienvenido a SEBOL</h2>
          <p className='text-center fs-6 text-secondary'> Welcome to SEBOL</p>
          {/* <hr className="hr-danger" /> */}

          {/* <h2 className="text-center mb-4">Sign Up</h2> */}
          <Card.Text className='text-justify'>
            Acá puedes inscribirte en la 14va Conferencia Boliviana de
            Desarrollo Económico BCDE14 y ser parte de las actividades de la
            Sociedad de Economistas de Bolivia (SEBOL)
            {/* <br/><br/>
        Al pagar la inscripción, recibirás una membresía de un año en SEBOL */}
          </Card.Text>
          <Card.Text className=' text-justify text-secondary'>
            This website allows you to register for the 14th annual Bolivian
            Conference on Development Economics (BCDE14) and be part of of the
            activities Bolivian Society of Economists (SEBOL)
          </Card.Text>
        </Card.Body>
        {/* <Image  src={require("../../images/Group9.jpeg")}
        rounded className="w-100 border-bottom" style={{ maxWidth: "400px"}}></Image> */}

        <Card.Body>
          {/* <h4 className="text-center">Bienvenido a BCDE 2022</h4>
      <p className="text-center fs-6 text-secondary"> Welcome to BCDE 2022</p>
      <hr className="hr-danger" />
      <Card.Text className="text-justify">

        Esta página te permite acceder a tu perfil, verificar tu inscricpion o pagar una inscripción pendiente.
        </Card.Text>
        <Card.Text className=" text-justify text-secondary">
        This page allows you to log in to your account, check your registration status or pay a pending registration fee.
        </Card.Text> */}
        </Card.Body>
      </Card>

      <Card className='mt-1'>
        <Card.Body>
          <h2 className='text-center mb-0'> Inicia Sesión</h2>
          <h5 className='text-center ft-12 text-secondary mb-4'> Log in</h5>
          {error && <Alert variant='danger'>{error}</Alert>}

          <p className='text-divider'>
            <span> Accede con tu cuenta de:</span>
          </p>

          <Button
            disabled={loading}
            className='w-100 mt-2'
            variant='danger'
            onClick={handleSubmitGoogle}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              fill='currentColor'
              className='bi bi-google'
              viewBox='0 0 16 16'
            >
              <path d='M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z' />
            </svg>{" "}
            Google
          </Button>

          <Button
            disabled={loading}
            className='w-100 mt-2'
            onClick={handleSubmitFacebook}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              fill='currentColor'
              className='bi bi-facebook'
              viewBox='0 0 16 16'
            >
              <path d='M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z' />
            </svg>{" "}
            Facebook
          </Button>

          <p className='text-divider'>
            <span> O usa tu email y contraseña</span>
          </p>

          <Form onSubmit={handleSubmit}>
            <Form.Group as={Row} id='email'>
              <Form.Label column xs={4}>
                Email
              </Form.Label>
              <Col xs={8}>
                <Form.Control
                  type='email'
                  placeholder='Your email'
                  ref={emailRef}
                  required
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} id='password' className='mt-2'>
              <Form.Label column xs={4}>
                Password
              </Form.Label>
              <Col xs={8}>
                <Form.Control
                  type='password'
                  placeholder='Your password'
                  ref={passwordRef}
                  required
                />
              </Col>
            </Form.Group>
            <Button
              disabled={loading}
              className='w-100 mt-4'
              variant='success'
              type='submit'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                fill='currentColor'
                className='bi bi-envelope'
                viewBox='0 0 16 16'
              >
                <path d='M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z' />
              </svg>{" "}
              Acceder via email
            </Button>
          </Form>

          <div className='w-100 text-center mt-2'>
            <div>¿Olvidaste tu contraseña?</div>
            <div className='fs-12 text-secondary'> Forgot password?</div>
            <Button variant='link' onClick={handleShow}>
              Recuperar constraseña | Reset password
            </Button>
          </div>
          <hr className='hr-danger' />
          <div className='text-center'>
            <div className=''>¿Necesitas una cuenta? </div>
            <div className='text-secondary'>Need and account?</div>
            {/* <Link to ="/signup">Crea una cuenta (sign up)</Link> <br/> */}

            <Button variant='link' onClick={handleShowEmailForm}>
              Create Account
            </Button>
          </div>
        </Card.Body>
      </Card>

      <Card className='mt-1'>
        <Card.Body>
          <div>
            <p className='text-center text-secondary mt-2'> Powered by:</p>
            <Image
              src={require("../../images/LogoRapiReservas.png")}
              rounded
              className='mx-auto d-block'
              style={{ maxWidth: "80px" }}
            ></Image>
          </div>
        </Card.Body>
      </Card>
    </CenteredContainer>
  )
}
